import Dictionary from "../../dictionary/dictionary";
import {CompanyModelForList} from "../../../models/company";
import {CompanyService} from "../../../services/companyService";
import i18n from "../../../../i18n/i18n";
import {Api} from "../../../../helpers/api";
import {NavLink} from "react-router-dom";
import {routingAddresses} from "../../../../helpers/routing";
import Button from "../../../../common/components/shared/button/button";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import {SortDirection} from "../../../../common/models/table";
import SearchButton from "../../../../common/components/shared/searchButton/searchButton";
import TextInput from "../../../../common/components/shared/textInput/textInput";

export default class CompaniesList extends Dictionary<CompanyModelForList> {
    private sortableElements = ["name", "taxNo", "phoneNo", "street", "city", "postalCode"];

    constructor(props: any) {
        super(props);

        this.canRemove = true;
        this.linkToModify = routingAddresses.dictionaries.companies.modify;
    }

    public async componentDidMount() {
        this.getData(await this.getAll());
    }

    public render(): JSX.Element {
        const properties = ["name", "taxNo", "phoneNo", "street", "city", "postalCode", "countryName"];
        const headers = properties.map(key => i18n.t("dictionaries.companies.headers." + key));
        const actions = this.renderActions;

        return (
            <div className="companies">
                {this.renderRemovePopup(this.confirmRemove.bind(this))}
                {this.renderWrapperContent(headers, properties, "companies", actions, undefined, this.getHeader(), this.sortableElements, this.sortingAction.bind(this))}
            </div>
        );
    }

    protected async confirmRemove() {
        this.setState({removeItemResponse: undefined, isWaiting: true});

        const response = await CompanyService.removeCompany(this.state.selectedElement!.id);

        this.setState({removeItemResponse: response});

        if (Api.isSuccess(response)) {
            await this.getData(await this.getAll());
            this.setState({selectedElement: undefined, displayRemovePopup: false});
        } else {
            this.setState({errorMessage: i18n.t("dictionaries.companies.errors.removeErrorSuffix")});
        }
        this.setState({isWaiting: false});
    }

    private getHeader() {
        return (
            <>
                <div className="filters">
                    <TextInput
                        className="search-input"
                        label={i18n.t("dictionaries.companies.headers.name")}
                        validatedValue={this.state.selectedValue}
                        testId="filters-name"
                    />
                    <TextInput
                        className="search-input"
                        label={i18n.t("dictionaries.companies.headers.taxNo")}
                        validatedValue={this.state.selectedTwoValue}
                        testId="filters-tax-no"
                    />
                </div>
                <div className="actions">
                    <SearchButton
                        isWaiting={this.state.isWaiting}
                        onClick={async () => {
                            this.setState({isWaiting: true, dictionaryData: undefined});
                            await this.getData(await this.getAll());
                            this.setState({isWaiting: false});
                        }}
                    />
                    <NavLink to={routingAddresses.dictionaries.companies.add} data-testid="add-company">
                        <Button type="primary" text={i18n.t("dictionaries.companies.actions.addCompany.button")}/>
                    </NavLink>
                    <ReloadButton
                        reloadFunc={this.reload.bind(this)}
                        testId="company-list-reload-btn"
                    />
                </div>
            </>
        );
    }

    private async reload() {
        this.reloadList(await this.getAll());
    }

    private async sortingAction(orderBy: string, sortDirection: SortDirection) {
        await this.setState({orderBy, sortDirection});
        await this.reload();
    }

    private async getAll() {
        return await CompanyService.getAll(
            {
                orderBy: this.state.orderBy,
                sortDirection: this.state.sortDirection
            },
            this.state.selectedValue.value.trim(),
            this.state.selectedTwoValue.value.trim()
        );
    }
}
